import script from "./create_vendor.vue?vue&type=script&setup=true&lang=js"
export * from "./create_vendor.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__